import { createApp } from "vue";
import App from "./App.vue";
import "./assets/tailwind.css";
import router from "./router";
import store from "./store";
import "@fortawesome/fontawesome-free/css/all.css";
import "flatpickr/dist/flatpickr.css";
import LoadingComponent from "@/components/LoadingComponent.vue";
import LoadingspinnerComponent from "./components/loadingspinnerComponent.vue";
import VideoDropdownModal from "./components/VideoDropdownModal.vue";
import HelpButton from "./components/HelpButton.vue";

const app = createApp(App);
app.use(store);
app.component("LoadingComponent", LoadingComponent);
app.component("LoadingspinnerComponent", LoadingspinnerComponent);
app.component("VideoDropdownModal", VideoDropdownModal);
app.component("HelpButton", HelpButton);

function getFileUrl(file) {
  if (file instanceof File) {
    return URL.createObjectURL(file);
  } else if (typeof file === "string" && file.trim()) {
    const fileName = file.split(/[/\\]/).pop();
    return `https://cdn.tryhisell.com/${fileName}`;
  } else {
    console.error("Invalid file input:", file);
    return null;
  }
}

app.provide("getFileUrl", getFileUrl);
app.use(router);
store.dispatch("initializeStore");
app.mount("#app");
